import { memo as Memo, useRef, useEffect } from 'react'

//* GSAP
import gsap from 'gsap'

//* HOC
import withUIContext from 'context/consumerHOC/UIConsumer'

//* Components
import Container from 'components/common/Container'
import Text from 'components/common/Text'

//* Helper
import { letterSpacingAnimation } from 'helpers'

//* Styles
import HeroSectionStyle from './style'

const HeroSection = Memo(({ title, text, isGatesActive }) => {
	//! Refs
	const titleRef = useRef()
	const textRef = useRef()

	//! Animation
	useEffect(() => {
		if (!isGatesActive) {
			letterSpacingAnimation([titleRef.current])

			gsap.to(textRef.current, { delay: 0.3, opacity: 1, duration: 1 })
		}
	}, [isGatesActive])

	return (
		<HeroSectionStyle>
			<Container row>
				<div className={`empty col-1 col-ts-12`} />

				<div className={`align-center col-10 col-ts-12`}>
					<h1
						ref={titleRef}
						className={`h4 minion3-medium primary-color9 uppercase opacity-zero`}
						dangerouslySetInnerHTML={{ __html: title }}
					/>

					<Text
						ref={textRef}
						tag={`h6`}
						className={`h6 minion3-regular primary-color9 cocktails-hero-text opacity-zero`}
						text={text}
					/>
				</div>

				<div className={`empty col-1 col-ts-12`} />
			</Container>
		</HeroSectionStyle>
	)
})

export default withUIContext(HeroSection, ['isGatesActive'])
